import React from 'react';
import PropTypes from 'prop-types';

import Filter, { FilterModal, FilterSection } from './Filter';
import CheckboxFilter from './FilterComponents/CoreComponents/CheckboxFilter';

import styles from '../search.scss';

const HSGradYearFilter = (props) => {
    const { type = '', filters, filterInputs, handleFilterClick, filterModal, closeModals, handleFilterSubmit, searchTypes, handleHSGradYearClick, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;
    const { gradYears = [] } = searchTypes;

    const selectedGradYears = filters?.hsGradYears && Object.keys(filters?.hsGradYears).filter(v => filters?.hsGradYears[v]).map(v => v).join(', ');
    const gradYearValue = selectedGradYears || 'All grad years';

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={'highSchool'}
                handleFilterClick={handleFilterClick}
                isActive={(filters && filters.hsGradYears && Object.values(filters.hsGradYears).indexOf(true) > -1) || filterModal === 'highSchool'}
                onClick={() => handleFilterClick('highSchool')}
                searchFor={type}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                {type === 'collegeCorner' ? gradYearValue : 'Graduating'}
            </Filter>
            {filterModal === 'highSchool' && (
                <FilterModal
                    title={'High School Grad Years'}
                    handleFilterSubmit={handleFilterSubmit}
                    onCloseClick={closeModals}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                        <CheckboxFilter
                            options={gradYears}
                            filterInputs={filterInputs}
                            filterInputName="hsGradYears"
                            onChange={handleHSGradYearClick}
                            data-testid={dataTestId && `${dataTestId}.options`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

HSGradYearFilter.propTypes = {
    type: PropTypes.string,
    filterInputs: PropTypes.instanceOf(Object).isRequired,
    filters: PropTypes.shape({
        hsGradYears: PropTypes.instanceOf(Object),
    }).isRequired,
    handleFilterClick: PropTypes.func.isRequired,
    filterModal: PropTypes.string.isRequired,
    closeModals: PropTypes.func.isRequired,
    handleFilterSubmit: PropTypes.func.isRequired,
    searchTypes: PropTypes.shape({
        gradYears: PropTypes.array,
    }),
    handleHSGradYearClick: PropTypes.func.isRequired,
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
    'data-testid': PropTypes.string,
};

HSGradYearFilter.defaultProps = {
    type: '',
    mobileOnly: false,
    desktopOnly: false,
    searchTypes: {
        gradYears: [],
    },
    'data-testid': undefined,
};

export default HSGradYearFilter;
